var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-wrapper",attrs:{"id":"app"}},[(_vm.updatePattern)?_c('CreateFeedContainer',{attrs:{"updatePattern":_vm.updatePattern}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }